export default "__VITE_ASSET__DWPYEW8j__"